<template>
  <generic-modal :title="$t('provider')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column is-three-fifths">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("library") }}</label>
            <div class="control">
              <div class="select">
                <select class="ui dropdown" v-model="meta.library">
                  <option value="nodemailer">{{ $t("nodemailer") }}</option>
                  <option value="mandrill">{{ $t("mandrill") }}</option>
                  <option value="grupogente">{{ $t("grupogente") }}</option>
                  <option value="sinch_sms">{{ $t("sinch sms") }}</option>
                  <option value="mailgun">{{ $t("mailgun") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nodemailer v-show="meta.library == 'nodemailer'" ref="nodemailer" />
      <mandrill v-show="meta.library == 'mandrill'" ref="mandrill" />
      <grupo-gente v-show="meta.library == 'grupogente'" ref="grupogente" />
      <sinch-sms v-show="meta.library == 'sinch_sms'" ref="sinch_sms" />
      <mailgun v-show="meta.library == 'mailgun'" ref="mailgun" />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import Nodemailer from "./Nodemailer.vue";
import Mandrill from "./Mandrill.vue";
import GrupoGente from "./GrupoGente.vue";
import SinchSms from "./SinchSms.vue";
import Mailgun from "./Mailgun.vue";

export default {
  name: "ProviderModal",
  components: {
    GenericModal,
    Nodemailer,
    Mandrill,
    GrupoGente,
    SinchSms,
    Mailgun,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      provider_uuid: undefined,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.library /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(provider_uuid) {
      let v = this;
      v.set_initial_state();
      if (provider_uuid) {
        get("/outbox/provider", { uuid: provider_uuid })
          .then((response) => {
            v.provider_uuid = provider_uuid;
            // console.log("response", response);
            v.meta.library = response.settings.library;
            v.meta.name = response.name;
            if (v.meta.library == "nodemailer") {
              v.$refs.nodemailer.set_data(response.settings.settings);
            } else if (v.meta.library == "mandrill") {
              v.$refs.mandrill.set_data(response.settings.settings);
            } else if (v.meta.library == "grupogente") {
              v.$refs.grupogente.set_data(response.settings.settings);
            } else if (v.meta.library == "sinch_sms") {
              v.$refs.sinch_sms.set_data(response.settings.settings);
            } else if (v.meta.library == "mailgun") {
              v.$refs.mailgun.set_data(response.settings.settings);
            }
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let config = {};
      if (v.meta.library == "nodemailer") {
        config = v.$refs.nodemailer.get_data();
      } else if (v.meta.library == "mandrill") {
        config = v.$refs.mandrill.get_data();
      } else if (v.meta.library == "grupogente") {
        config = v.$refs.grupogente.get_data();
      } else if (v.meta.library == "sinch_sms") {
        config = v.$refs.sinch_sms.get_data();
      } else if (v.meta.library == "mailgun") {
        config = v.$refs.mailgun.get_data();
      }

      // v.$emit("success", {
      //   name: v.provider.name,
      //   config: config,
      //   meta: v.meta,
      // });

      if (v.provider_uuid) {
        post("/outbox/provider", {
          uuid: v.provider_uuid,
          name: v.meta.name,
          settings: config,
          library: v.meta.library,
        })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/outbox/provider", {
          name: v.meta.name,
          settings: config,
          library: v.meta.library,
        })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        library: "",
        name: "",
        // barcode: "",
        // sale_price: "",
        // settings: {},
      };
      v.$refs.nodemailer.clear();
      v.$refs.mandrill.clear();
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
